import React from "react";
import { Navigate } from "react-router-dom";
import { isProyectosJefeRole } from "../../utils/proyectosRol";

type Props = { element: React.ReactElement };

export default function JefeProyectosRoute({ element }: Props) {
  const authed = !!localStorage.getItem("authToken");
  if (!authed) return <Navigate to="/" replace />;
  if (!isProyectosJefeRole()) return <Navigate to="/dashboard" replace />;
  return element;
}
